//WE.Flow.Html.Contracts.Manifests.Components.UserContextTabManifest

export class UserContextTabManifest {
    isUserContextTab: boolean = false;
    id: string = "";
    name: string = "";
    defaultParameters: any = null;
    viewUrl: string = "";
    namespace: string = "";
    viewModelId: string = "";
    icon: string = "";
    cssUrls: string[] = null;
    useFormValidation: boolean = false;
    reuseInstance: boolean = false;
    order: number = 0;
    tags: string[] = null;
}
